import { render, staticRenderFns } from "./IndicatorsButtons.vue?vue&type=template&id=ff8523b8&scoped=true"
import script from "./IndicatorsButtons.vue?vue&type=script&lang=js"
export * from "./IndicatorsButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8523b8",
  null
  
)

export default component.exports